import React from 'react';
import { BrowserRouter, Routes, Route} from 'react-router-dom';

import Home from './Home';
import Landing from "./Landing";
import PTA from './PTA';
import LanguageClass from './Language-Class';
import ActivityClass from './Activity-Class';
import Student from './Student';
import Newsletter from './Newsletter';
import Club from './Club';

import SignIn from './Signin';
import SignUp from './Signup';
import About from './About';
import Registration from './Registration';
import SchoolCalendar from './Calendar';
import AdminPortal from './AdminPortal';

import Grade1 from './LanguageCources/Grade1';
import Grade2 from './LanguageCources/Grade2';
import GradePreK from './LanguageCources/GradePreK';

export default function Main() {
    return (
       <BrowserRouter>
            <Routes>
                {/* <Route exact path="/" element={<Home />} /> */}
                <Route exact path="/" element={<Landing />} />
                <Route exact path="/home" element={<Home />} />
                <Route exact path="/newsletter" element={<Newsletter />} />
                <Route exact path="/student" element={<Student />} />
                <Route exact path="/language-class" element={<LanguageClass />} />
                <Route exact path="/activity-class" element={<ActivityClass />} />
                <Route exact path="/pta" element={<PTA />} />
                <Route exact path="/signup" element={<SignUp />} />
                <Route exact path="/signin" element={<SignIn />} />
                <Route exact path="/about" element={<About />} />
                <Route exact path="/registration" element={<Registration />} />
                <Route exact path="/school-calendar" element={<SchoolCalendar />} />
                <Route exact path="/portal" element={<AdminPortal />} />

                <Route exact path="/language-class/grade1" element={<Grade1 />} />
                <Route exact path="/language-class/grade2" element={<Grade2 />} />
                <Route exact path="/language-class/grade-prek" element={<GradePreK />} />

                <Route exact path="/club" element={<Club />} />
                
            </Routes>
        </BrowserRouter>
    );
}
